﻿import { DocumentType, ManufacturerTypes, MimeType } from "../models/enums";

export class IconTemplates {

    static renderDocumentFileType(doc: any) {
        switch (doc.mimeType) {
            case MimeType.Bmp:
            case MimeType.Gif:
            case MimeType.Jpeg:
            case MimeType.Png:
            case MimeType.Tiff:
                return <div className="image-thumb-icon-container"><i className="dx-icon-image image-thumb-icon pw-azure"></i></div>;

            case MimeType.Mp4:
            case MimeType.Mpeg:
                return <div className="image-thumb-icon-container"><i className="dx-icon-video image-thumb-icon pw-pink"></i></div>;

            case MimeType.Csv:
                return <div className="image-thumb-icon-container"><i className="dx-icon-txtfile image-thumb-icon pw-light-green"></i></div>;

            case MimeType.Pdf:
                return <div className="image-thumb-icon-container"><i className="dx-icon-pdffile image-thumb-icon pw-red"></i></div>;

            case MimeType.Html:
                return <div className="image-thumb-icon-container"><i className="dx-icon-globe image-thumb-icon pw-dark-purple"></i></div>;

            case MimeType.Json:
                return <div className="image-thumb-icon-container"><span className="material-symbols-outlined tab-icon pw-blue">data_object</span></div>;

            case MimeType.Xml:
                return <div className="image-thumb-icon-container"><i className="dx-icon-codeblock image-thumb-icon pw-green"></i></div>;

            case MimeType.Zip:
                return <div className="image-thumb-icon-container"><i className="dx-icon-image image-thumb-icon pw-light-green"></i></div>;

            case MimeType.MicrosoftExcel:
                return <div className="image-thumb-icon-container"><i className="dx-icon-xlsfile image-thumb-icon pw-green"></i></div>;

            case MimeType.MicrosoftExcelX:
                return <div className="image-thumb-icon-container"><i className="dx-icon-xlsxfile image-thumb-icon pw-green"></i></div>;

            case MimeType.MicrosoftWord:
                return <div className="image-thumb-icon-container"><i className="dx-icon-docfile image-thumb-icon pw-blue"></i></div>;

            case MimeType.MicrosoftWordX:
                return <div className="image-thumb-icon-container"><i className="dx-icon-docxfile image-thumb-icon pw-blue"></i></div>;

            case MimeType.MicrosoftPowerPoint:
                return <div className="image-thumb-icon-container"><i className="dx-icon-pptfile image-thumb-icon pw-orange"></i></div>;

            case MimeType.MicrosoftPowerPointX:
                return <div className="image-thumb-icon-container"><i className="dx-icon-pptxfile image-thumb-icon pw-orange"></i></div>;

            default:
                return <div className="image-thumb-icon-container"><i className="dx-icon-textdocument image-thumb-icon"></i></div>;
        }
    }

    static renderStandardCofAType(doc: any) {
        switch (doc.documentType) {
            case DocumentType.AbsoluteStandardsCoa:
                return <div className="coa-thumb-icon-container absolute-standards-icon"></div>;

            case DocumentType.AccuStandardCoa:
                return <div className="coa-thumb-icon-container accu-standard-icon"></div>;

            case DocumentType.BritishPharmacopoeiaCoa:
                return <div className="coa-thumb-icon-container bp-icon"></div>;

            case DocumentType.InorganicVenturesCoa:
                return <div className="coa-thumb-icon-container inorganic-ventures-icon"></div>;

            case DocumentType.RestekCoa:
                return <div className="coa-thumb-icon-container restek-icon"></div>;

            case DocumentType.MilliporeSigmaCoa:
                return <div className="coa-thumb-icon-container millipore-sigma-icon"></div>;

            case DocumentType.SigmaAldrichCoa:
                return <div className="coa-thumb-icon-container millipore-sigma-icon"></div>;

            case DocumentType.SupelcoCoa:
                return <div className="coa-thumb-icon-container millipore-sigma-icon"></div>;

            case DocumentType.UnitedStatesPharmacopiaCoa:
                return <div className="coa-thumb-icon-container usp-icon"></div>;

            default:
                return <div className="coa-thumb-icon-container"><i className="dx-icon-textdocument image-thumb-icon"></i></div>;

        }
    }
}